import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/lifetimeValueByMembershipsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypeFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.lifetimeValueByMembership.filters.membership_types);
  const selectedFilters = useSelector(
    (state) => state.lifetimeValueByMembership.selectedFilters.membership_types
  );

  return options.length ? (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Select Action"
      height={324}
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ membership_types: data }))}
    />
  ) : null;
};

export default MembershipTypeFilter;
